module.exports = __webpack_public_path__ + "img/podium_4100.737da059.jpg";